export default "__VITE_ASSET__DWHlHvKD__"